import axios from 'axios'
import { Config } from './initialConfig'
import * as Sentry from '@sentry/react'
import { upperCase } from 'lodash'
import { store } from 'store'
import { authActions } from 'store/reducers/auth'
import { toast } from 'react-toastify'

export const URL_API = Config?.REACT_APP_API_BASE_URL

const authEndpoints = ['get-otp-login', 'resend-otp-login', 'login']

export const Axios = axios.create({
  baseURL: URL_API,
  headers: { Accept: 'application/json', 'Content-Type': ['text/plain', 'application/json'] }
})

Axios.interceptors.request.use((config) => {
   const token = store.getState().auth.access_token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

Axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  },
  function (error) {
    // Error dari endpoint login (mis. 403 user admin) harus ditampilkan di halaman login,
    // bukan memicu logout yang me-reload halaman dan menghilangkan pesan errornya
    const isAuthEndpoint = authEndpoints.includes(error?.config?.url)
    if (
      !isAuthEndpoint &&
      ([401, 403]?.includes(error?.response?.status) ||
        error?.response?.data?.errors?.[0]?.message?.includes('Invalid Token'))
    ) {
      store.dispatch(authActions.logout())
    }
    if (error?.response?.data?.errors?.[0]?.message?.includes('Akun Anda sedang dinonaktifkan')) {
      const token = store.getState().auth.access_token
      if (token) {
         toast.error(error?.response?.data?.errors?.[0]?.message);
         store.dispatch(authActions.logout())
      }
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
  }
)
